import { all, takeLatest, call, put, select } from 'redux-saga/effects';

import { ON_GOING, UNRATE } from '@coconut/constants/questions';

import {
  getQuestionStageExpiration,
  setAnswerStage as setAnswerStageApi,
} from '../apis/chat';
import { getAasmState } from '../redux/selectQuestion';
import {
  types,
  fetchAnswerStageSuccess,
  fetchAnswerStageFailed,
  setAnswerStageFailed,
} from '../redux/answerStage';
import {
  hideChatStageModal,
  updateStageAndShowChatStageModal,
} from '../redux/chatModal';
import {
  WAITING_REPLY,
  MARK_QUESTION_COMPLETE,
} from '../constants/answerStages';
import { showChatAlertBanner } from '../redux/chatAlertBanner';
import {
  SUCCESS_TIMER_THEME,
  SESSION_ENDED_THEME,
  WAITING_REPLY_TIMER_THEME,
} from '../constants/chatBannerThemes';
import { getRole } from '@coconut/services/redux/profile';
import { TUTOR, STUDENT } from '@coconut/constants/userRole';

import { parseDate } from '@coconut/utils/datetimeformator';

function* markQuestionComplete() {
  yield put(hideChatStageModal());

  const aasmState = yield select(getAasmState);
  if (aasmState === UNRATE) {
    return;
  }

  if (aasmState === ON_GOING) {
    // Logic to show alert banner.
    yield put(showChatAlertBanner(SUCCESS_TIMER_THEME));
  } else {
    // Logic to show end session banner.
    yield put(showChatAlertBanner(SESSION_ENDED_THEME));
  }
}

function* transformResponse(response) {
  const {
    data: {
      answer_stage: answerStage,
      current_stage_expired_at: currentStageExpiredAt,
    },
  } = response;
  const role = yield select(getRole);
  const expireAtDate = currentStageExpiredAt || '1970-01-01 00:00:00 +0000';

  const expireAt = parseDate(expireAtDate).getTime() / 1000;
  // update selected question.
  yield put(
    fetchAnswerStageSuccess({
      expireAt,
      answerStage,
    })
  );

  if (answerStage === MARK_QUESTION_COMPLETE) {
    yield call(markQuestionComplete);

    return;
  }

  if (answerStage === WAITING_REPLY) {
    if (role === STUDENT) {
      // Logic to show chat stage modal
      yield put(updateStageAndShowChatStageModal(WAITING_REPLY));
    }

    if (role === TUTOR) {
      yield put(showChatAlertBanner(WAITING_REPLY_TIMER_THEME));
    }

    return;
  }
}

export function* fetchAnswerStageFlow(action) {
  const { QID } = action.payload;

  try {
    const response = yield call(getQuestionStageExpiration, QID);

    yield call(transformResponse, response);
  } catch (err) {
    yield put(fetchAnswerStageFailed(err.message));
  }
}

export function* setAnswerStageFlow(action) {
  try {
    const response = yield call(setAnswerStageApi, action.payload);

    yield call(transformResponse, response);
  } catch (err) {
    yield put(setAnswerStageFailed(err.message));
  }
}

export default function* () {
  yield all([
    takeLatest(types.FETCH_ANSWER_STAGE, fetchAnswerStageFlow),
    takeLatest(types.SET_ANSWER_STAGE, setAnswerStageFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/answerStage.js